import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { useParams } from 'react-router-dom';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { fetchTransactionsStats } from '../../actions/transactions';
import TransactionsStats from '../../components/TransactionsStats';
import useAPI from '../../hooks/useAPI';

const ContractTransactions = () => {
  const { contractAddress } = useParams();

  const { silo, contractCurrency } = useSelector(state =>
    get(state, `entities.contracts.${contractAddress}`, { metadata: {} }),
  );

  const transactionStats = useSelector(state =>
    get(state, 'pagination.transactionsStats', undefined),
  );

  const { isLoading } = useAPI(() => fetchTransactionsStats({ contractAddress, silo }));

  return (
    <>
      {isLoading && <Spinner size={SpinnerSize.medium} data-testid="transactionSpinner" />}
      {!isLoading && (
        <TransactionsStats
          totalEarnedRoyalty={transactionStats?.totalEarnedRoyalty}
          totalTransactionsQuantity={transactionStats?.totalTransactionsQuantity}
          currency={contractCurrency}
          statementDates={transactionStats?.statementDates}
          noTransactionDataMessage="Transactions have not yet been processed since the last statement."
        />
      )}
    </>
  );
};

export default ContractTransactions;
